import { WidgetRegistry, WidgetDefinition, WidgetSettings } from "../../models/Dashboard";

class WidgetRegistryService implements WidgetRegistry {
  private widgets: Map<string, WidgetDefinition> = new Map();

  register<TData, TSettings extends WidgetSettings>(
    definition: WidgetDefinition<TData, TSettings>
  ): void {
    if (this.widgets.has(definition.id)) {
      console.warn(
        `Widget "${definition.id}" is already registered. Overwriting.`
      );
    }
    this.widgets.set(definition.id, definition as any);
  }

  get(id: string): WidgetDefinition<any, any> | undefined {
    return this.widgets.get(id);
  }

  getAll(): WidgetDefinition<any, any>[] {
    return Array.from(this.widgets.values());
  }

  has(id: string): boolean {
    return this.widgets.has(id);
  }

  debug(): void {
    console.log(
      "Registered Widgets:",
      Array.from(this.widgets.entries()).map(([id, def]) => ({
        id,
        title: def.title,
        hasCustomSettings: !!def.SettingsPanel,
        supportsExport: def.supportsExport ?? false,
      }))
    );
  }
}

export const widgetRegistryService = new WidgetRegistryService();
export const widgetRegistry = widgetRegistryService;

export const registerWidgets = (
  definitions: WidgetDefinition<any, any>[]
): void => {
  definitions.forEach((def) => widgetRegistryService.register(def));
};
